import {createAction} from '@reduxjs/toolkit'

/** 안심 번호 선택 */
export const selectUseVirtualPhoneNumber = createAction<boolean>('deliveryInfo/selectUseVirtualPhoneNumber')
